import imageCompression from "browser-image-compression"

export interface CompressionOptions {
  maxSizeMB?: number
  maxWidthOrHeight?: number
  useWebWorker?: boolean
  onProgress?: (progress: number) => void
}

export interface CompressionResult {
  compressedFile: File
  originalSize: number
  compressedSize: number
  compressionRatio: number
}

export const compressImage = async (
  file: File,
  options: CompressionOptions = {}
): Promise<CompressionResult> => {
  const { maxSizeMB = 1, maxWidthOrHeight = 1920, useWebWorker = true, onProgress } = options

  const compressionOptions = {
    maxSizeMB,
    maxWidthOrHeight,
    useWebWorker,
    onProgress,
  }

  try {
    const compressedFile = await imageCompression(file, compressionOptions)

    const originalSize = file.size
    const compressedSize = compressedFile.size
    const compressionRatio = ((originalSize - compressedSize) / originalSize) * 100

    return {
      compressedFile,
      originalSize,
      compressedSize,
      compressionRatio,
    }
  } catch (error) {
    console.error("Image compression failed:", error)
    throw new Error("Failed to compress image")
  }
}

export const compressImageWithLoading = async (
  file: File,
  onProgress: (progress: number) => void,
  options: Omit<CompressionOptions, "onProgress"> = {}
): Promise<CompressionResult> => {
  return compressImage(file, {
    ...options,
    onProgress,
  })
}
